"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PadsTab = void 0;
const router_1 = require("client/components/router");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const edit_pads_1 = require("../../components/edit-pads");
const store_1 = require("../../store");
let PadsTab = class PadsTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.onCancelEditPads = () => {
            router_1.RouteManager.transitionTo("/pads");
        };
    }
    render() {
        const siteId = Number(this.props.params[0]);
        return (React.createElement("div", { className: "sites__form" },
            React.createElement(edit_pads_1.EditPads, { error: store_1.sitesDetailStore.site.error, loading: store_1.sitesDetailStore.site.loading, onCancel: this.onCancelEditPads, site: siteId ? store_1.sitesDetailStore.site.value : null })));
    }
};
PadsTab = __decorate([
    mobx_react_1.observer
], PadsTab);
exports.PadsTab = PadsTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/tabs/pads/pads.tsx
// module id = 4044
// module chunks = 0